"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsFullScreenButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Fullscreen = _interopRequireDefault(require("@mui/icons-material/Fullscreen"));
var _FullscreenExit = _interopRequireDefault(require("@mui/icons-material/FullscreenExit"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsFullScreenButton = () => {
  const [isFullScreen, setIsFullScreen] = _react.default.useState(false);
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };
  _react.default.useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullScreenChange);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    color: "inherit",
    onClick: toggleFullScreen
  }, isFullScreen ? /*#__PURE__*/_react.default.createElement(_FullscreenExit.default, null) : /*#__PURE__*/_react.default.createElement(_Fullscreen.default, null));
};
exports.DmsFullScreenButton = DmsFullScreenButton;